export default __webpack_public_path__ + "static/media/img-ltsh-7.316414e4.png";